import { BookingServices } from '../types';
import { BufferstockAdapter } from './adapters/bufferstock-adapter';
import { MachineAdapter } from './adapters/machine-adapter';
import { CarAdapter } from './adapters/car-adapter';
import { UserAdapter } from './adapters/user-adapter';
import { MovementAdapter } from './adapters/movement-adapter';
import { ArticleAdapter } from './adapters/article-adapter';
import { StockObjectAdapter } from './adapters/stock-object-adapter';
import { TransactionAdapter } from './adapters/transaction-adapter';
import { PendingCommitAdapter } from './adapters/pending-commit-adapter';

/**
 * Fassade, die alle Model-Adapter des Buchungsmoduls bündelt und zentral
 * bereitstellt. Jeder Adapter erhält eine Rückreferenz auf diese Instanz,
 * damit die Adapter untereinander auf die jeweils anderen zugreifen können.
 */
export class ModelAdapters {
  public readonly article: ArticleAdapter;
  public readonly stockObject: StockObjectAdapter;
  public readonly bufferstock: BufferstockAdapter;
  public readonly machine: MachineAdapter;
  public readonly car: CarAdapter;
  public readonly user: UserAdapter;
  public readonly movement: MovementAdapter;
  public readonly transaction: TransactionAdapter;
  public readonly pendingCommit: PendingCommitAdapter;

  /**
   * Instanziiert alle Adapter mit den geteilten Buchungs-Services und reicht
   * jeweils diese Fassade als Rückreferenz durch.
   * @param services Gebündelte Services, die alle Adapter zur Datenbeschaffung nutzen.
   */
  constructor(services: BookingServices) {
    this.article = new ArticleAdapter(services, this);
    this.stockObject = new StockObjectAdapter(services, this);
    this.bufferstock = new BufferstockAdapter(services, this);
    this.machine = new MachineAdapter(services, this);
    this.car = new CarAdapter(services, this);
    this.user = new UserAdapter(services, this);
    this.movement = new MovementAdapter(services, this);
    this.transaction = new TransactionAdapter(services, this);
    this.pendingCommit = new PendingCommitAdapter(services, this);
  }
}
